var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "evaluation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7404",
    "data-name": "Rectangle 7404",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rating-svgrepo-com",
    transform: "translate(1.84 1.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11048",
    "data-name": "Path 11048",
    d: "M16.2,9.028,17.875,7.4a.824.824,0,0,0-.457-1.405l-5.264-.765L9.8.459a.824.824,0,0,0-1.477,0L5.969,5.229.705,5.994A.824.824,0,0,0,.249,7.4l3.809,3.713-.9,5.242a.824.824,0,0,0,1.2.868L8.8,14.886A5.766,5.766,0,1,0,16.2,9.028ZM5.065,14.987l.69-4.024a.824.824,0,0,0-.237-.729L2.594,7.384,6.635,6.8a.824.824,0,0,0,.62-.451L9.062,2.685l1.807,3.661a.824.824,0,0,0,.62.451l4.04.587-1.46,1.423A5.78,5.78,0,0,0,9,13a.822.822,0,0,0-.323.091Zm9.489,3.685a4.119,4.119,0,1,1,4.119-4.119A4.124,4.124,0,0,1,14.554,18.673Z",
    transform: "translate(0 0)",
    fill: "#02466a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11049",
    "data-name": "Path 11049",
    d: "M221.931,226.5a1.436,1.436,0,0,1-1.983,0,1.593,1.593,0,0,0-1.512,1.237,2.121,2.121,0,0,0,.328,1.686,5.218,5.218,0,0,0,1.978,1.695.412.412,0,0,0,.394,0,5.22,5.22,0,0,0,1.978-1.695,2.121,2.121,0,0,0,.329-1.686A1.593,1.593,0,0,0,221.931,226.5Z",
    transform: "translate(-206.386 -214.06)",
    fill: "#02466a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluation);
export default __webpack_public_path__ + "static/media/evaluation.39047ca8765662482140d9607fc47bb0.svg";
export { ForwardRef as ReactComponent };